import { render, staticRenderFns } from "./shopReturn.vue?vue&type=template&id=686994d3&scoped=true"
import script from "./shopReturn.vue?vue&type=script&lang=js"
export * from "./shopReturn.vue?vue&type=script&lang=js"
import style0 from "./shopReturn.vue?vue&type=style&index=0&id=686994d3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686994d3",
  null
  
)

export default component.exports